import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import BlogSection from "../../components/blogsection/BlogSection";
import BlogCard from "../../components/blogcard/BlogCard";
import Spinner from "../../components/spinner/Spinner";
import { db } from "../../firebase";
import "./tagblog.css";

const TagBlog = ({ setActive }) => {
  const [tagBlogs, setTagBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const { tag } = useParams();

  const getTagBlogs = async () => {
    setLoading(true);
    const blogRef = collection(db, "blogs");
    const tagBlogQuery = query(blogRef, where("tags", "array-contains", tag));
    const docSnapshot = await getDocs(tagBlogQuery);
    let tagBlogs = [];
    docSnapshot.forEach((doc) => {
      tagBlogs.push({ id: doc.id, ...doc.data() });
    });
    setTagBlogs(tagBlogs);
    setLoading(false);
  };

  useEffect(() => {
    document.title = `${tag} - youvaraj.com`;
    getTagBlogs();
    setActive(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tag]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="tag-page">
      <div className="container">
        <div className="page-title-header">
          <h1 className="page-title">#{tag}</h1>
          <p className="page-subtitle">All blogs tagged with {tag}</p>
        </div>
        <div className="row">
          {tagBlogs?.map((item) => (
            <div className="col-md-6" key={item.id}>
              <BlogCard {...item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TagBlog;
